import _groupBy from 'lodash.groupby';
import ShDividerLine from '@/components/Helpers/ShDividerLine';
import { API } from '@/config';
import ShButton from '@/components/Helpers/ShButton';
import PackageGroup from './PackageGroup';

// @vue/component
export default {
  name: 'ShopWithAvailablePackages',

  components: {
    ShButton,
    PackageGroup,
    ShDividerLine,
  },

  data() {
    return {
      selectedPackage: {},
      isWaitingForRedirectToPayments: false,
      activePackage: {},
    };
  },

  computed: {
    packagesPerCategory() {
      return _groupBy(this.$store.getters['settings/packageDefinitions'], 'category');
    },
    packagesGroups() {
      return Object.keys(this.packagesPerCategory);
    },
    isLoading() {
      return this.$store.getters['app/pendingStoreActions'].includes([
        'settings/getPackageDefinitions',
        'promotionCodes/getOne',
      ]);
    },
    isDisabled() {
      return !this.$store.getters['authorization/hasRequiredAccountData'];
    },
    promotionCode() {
      return this.$store.getters['promotionCodes/one'][0];
    },
    promotionPackages() {
      return this.promotionCode ? this.promotionCode.package_definitions_ids.split(',').map(id => parseInt(id, 10)) : [];
    },
    savedPrice() {
      if (this.promotionCode.type !== 'percent') return 0;
      return ((this.promotionCode.value / 100) * this.activePackage.price).toFixed(2);
    },
    additionalAmount() {
      return this.promotionCode.value;
    },
    middleOfPackageDefinitions() {
      return Math.floor(this.$store.getters['settings/packageDefinitions'].length / 2);
    },
  },

  async created() {
    await this.$store.dispatch('settings/getPackageDefinitions');
    // eslint-disable-next-line prefer-destructuring
    this.selectedPackage = this.$store.getters['settings/packageDefinitions'][this.middleOfPackageDefinitions];
    // eslint-disable-next-line prefer-destructuring
    this.activePackage = this.$store.getters['settings/packageDefinitions'][this.middleOfPackageDefinitions];
    await this.$store.dispatch('promotionCodes/getOne');
  },

  methods: {
    handleGoToAccount() {
      this.$EventBus.$emit('TOGGLE_PACKAGE_SHOP', false);
      this.$router.push({ name: 'Account' });
    },
    setActivePackage(packagee) {
      this.activePackage = packagee;
    },
    async handlePurchase() {
      this.isWaitingForRedirectToPayments = true;
      if (!this.activePackage) return;
      const { url } = (await API.put('/package/purchase', { package_id: this.activePackage.id })).data.data;
      this.isWaitingForRedirectToPayments = false;
      window.location.href = url;
    },
  },
};
